export const RadioField = ({ field, register }) => (
  <div className="space-y-2">
    {field.options?.map((option) => (
      <label key={option.value} className="flex items-center space-x-2">
        <input
          type="radio"
          {...register(field.id, field.validation)}
          value={option.value}
          disabled={field.disabled}
        />
        <span className="text-sm">{option.label}</span>
      </label>
    ))}
  </div>
);
